/*
  © 2025 Jhango
  https://www.jhango.com
*/

function debounce(fn, wait) {
  let timer;
  return function(...args) {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), wait);
  };
}

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form.search-form");
    this.input = this.form.querySelector('input[type="search"]');
    this.results = this.form.querySelector("#predictive-search");
    this.status = this.form.querySelector("#predictive-search-status");

    this.emptyContainer = document.getElementById("ps-empty-state");
    this.cartUpsells = this.querySelector("#card-upsells-collapse-wrapper");

    this.input.addEventListener(
      "input",
      debounce(() => {
        this.getSearchResults();
      }, 300)
    );

    document
      .querySelector("#offcanvas-search")
      ?.addEventListener("shown.bs.offcanvas", () => {
        this.input.focus();
      });
    this.accessibilityEventIsInit = false;
  }

  async getSearchResults() {
    const searchTerm = this.input.value.trim();

    if (searchTerm.length) {
      const response = await fetch(
        `${window.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=${this.dataset.resourcesType}&resources[limit]=10&section_id=predictive-search`
      );

      if (response.ok) {
        const data = await response.text();
        const doc = new DOMParser().parseFromString(data, "text/html");
        const sectionEl = doc.querySelector("#shopify-section-predictive-search");
        if (!sectionEl) return;

        this.results.innerHTML = sectionEl.innerHTML;

        this.emptyContainer.setAttribute("hidden", "hidden");
        if (this.cartUpsells) this.cartUpsells.setAttribute("hidden", "hidden");
        this.input.setAttribute("aria-expanded", "true");

        const resultsEl = this.querySelector("#predictive-search-results");
        if (resultsEl && this.status) {
          this.status.textContent = resultsEl.dataset.resultsText || '';
        }

        this.results
          .querySelectorAll(".jdgm-prev-badge__stars")
          .forEach((elem) => {
            elem.setAttribute("tabindex", "-1");
          });
        this.handleAccessibility();
      }
    } else {
      this.emptyContainer.removeAttribute("hidden");
      if (this.cartUpsells) this.cartUpsells.removeAttribute("hidden");
      this.results.innerHTML = "";
      this.input.setAttribute("aria-expanded", "false");
      this.input.removeAttribute("aria-activedescendant");
      if (this.status) this.status.textContent = "";
    }
  }

  handleAccessibility() {
    let x = -1;

    function listenKeyup(event) {
      const items = this.querySelectorAll(
        "#predictive-search-results a, #predictive-search-results button"
      );

      if (!items.length) return;

      if (event.code === "ArrowUp" || event.code === "ArrowDown") {
        items.forEach((elem) => {
          elem
            .closest('[role="option"]')
            .setAttribute("aria-selected", "false");
        });
      }

      switch (event.code) {
        case "ArrowUp":
          if (x <= 0) x = items.length;
          x--;
          items.forEach((elem, index) => {
            if (index === x) {
              elem.focus();
              elem.closest('[role="option"]').setAttribute("aria-selected", "true");
              this.input.setAttribute(
                "aria-activedescendant",
                elem.closest('[role="option"]').getAttribute("id")
              );
            }
          });
          break;
        case "ArrowDown":
          if (x === items.length - 1) x = -1;
          x++;
          items.forEach((elem, index) => {
            if (index === x) {
              elem.focus();
              elem.closest('[role="option"]').setAttribute("aria-selected", "true");
              this.input.setAttribute(
                "aria-activedescendant",
                elem.closest('[role="option"]').getAttribute("id")
              );
            }
          });
          break;
      }
    }

    if (!this.accessibilityEventIsInit) {
      this.addEventListener("keyup", listenKeyup);
      this.accessibilityEventIsInit = true;
    }
  }
}

customElements.define("predictive-search", PredictiveSearch);
